import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { IGX_DIALOG_DIRECTIVES, IgxDialogComponent, IgxDialogModule } from '@infragistics/igniteui-angular/dialog';
import { OverlaySettings } from '@infragistics/igniteui-angular/core';
import { IgxIconComponent, IgxIconModule } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective } from '@infragistics/igniteui-angular/directives';
import { IGX_NAVBAR_DIRECTIVES, IgxNavbarModule } from '@infragistics/igniteui-angular/navbar';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-question-dialog',
  templateUrl: './question-dialog.component.html',
  styleUrls: ['./question-dialog.component.scss'],
  imports: [
    IgxDialogModule,
    IGX_DIALOG_DIRECTIVES,
    TranslateModule,
    IgxNavbarModule,
    IGX_NAVBAR_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxIconModule,
    IgxIconComponent,
    IgxFocusDirective
  ]
})
export class QuestionDialogComponent implements OnInit {
  @ViewChild('questionDialog', {read: IgxDialogComponent, static: true})
  public questionDialog: IgxDialogComponent;
  @Output() evtResuelto = new EventEmitter<boolean>();

  public questionTitulo: string;
  public questionMensaje: string;
  public questionIcon: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  public abrir(mensaje: string, titulo: string, icon: string, overlaySettings: OverlaySettings) {
    this.questionTitulo = titulo;
    this.questionMensaje = mensaje;
    this.questionIcon = icon;
    this.questionDialog.open(overlaySettings);
  }

  public btnRespuesta(resp: boolean) {
    this.questionDialog.close();
    this.evtResuelto.emit(resp);
  }
}
